// С какого количества сундуков за одну покупку действует скидка
// discountPercentsFor10ItemsPurchase из конфига сундука (любое количество
// от этого порога, кратность 10 не требуется)
export const CHEST_DISCOUNT_MIN_QUANTITY = 10;

// Перк премиума: дополнительная скидка на покупку сундуков ЗА КРИСТАЛЛЫ.
// Складывается с оптовой скидкой (15% опт + 10% премиум = 25%) при
// действующем премиуме на момент покупки
export const PREMIUM_CHEST_CRYSTALS_DISCOUNT_PERCENTS = 10;

/**
 * Суммарная цена покупки сундуков с учетом оптовой скидки и премиум-скидки
 * (10% на сундуки за кристаллы при действующем премиуме; проценты скидок
 * складываются). Используется и клиентом (плашка/модалка магазина), и
 * сервером (/api/buy-chest) — расчет обязан совпадать.
 *
 * @returns {{
 *   totalPrice: number,
 *   appliedDiscountPercents: number|null,
 *   appliedPremiumDiscountPercents: number|null,
 *   effectiveDiscountPercents: number,
 *   isNumensPrice: boolean,
 *   unitPrice: number,
 * }}
 */
export const calcChestsTotalPrice = (chestConfig, quantity, {isPremiumActive = false} = {}) => {
  const isNumensPrice = !chestConfig.priceCrystals && chestConfig.priceNumens > 0;
  const unitPrice = isNumensPrice ? (chestConfig.priceNumens || 0) : (chestConfig.priceCrystals || 0);
  const basePrice = unitPrice * quantity;

  const discountPercents = chestConfig.discountPercentsFor10ItemsPurchase || 0;
  const isBulkDiscountApplied = discountPercents > 0 && quantity >= CHEST_DISCOUNT_MIN_QUANTITY;
  const isPremiumDiscountApplied = isPremiumActive && !isNumensPrice;

  // Проценты скидок СКЛАДЫВАЮТСЯ (15% опт + 10% премиум = 25%) и применяются
  // одним множителем; суммарный процент идет и в бейджи у кнопок покупки.
  // Округление вниз — скидка не меньше заявленной
  const effectiveDiscountPercents = (isBulkDiscountApplied ? discountPercents : 0)
    + (isPremiumDiscountApplied ? PREMIUM_CHEST_CRYSTALS_DISCOUNT_PERCENTS : 0);
  const totalPrice = effectiveDiscountPercents > 0
    ? Math.floor(basePrice * (100 - effectiveDiscountPercents) / 100)
    : basePrice;

  return {
    totalPrice,
    appliedDiscountPercents: isBulkDiscountApplied ? discountPercents : null,
    appliedPremiumDiscountPercents: isPremiumDiscountApplied
      ? PREMIUM_CHEST_CRYSTALS_DISCOUNT_PERCENTS
      : null,
    effectiveDiscountPercents,
    isNumensPrice,
    unitPrice,
  };
};
